/* VD wishlist page renderer.
   Reads the saved product HANDLES from localStorage['vd_wishlist'] (written by vd-cards.js hearts)
   and renders each as a VD product card, fetched via the Section Rendering API
   (/products/{handle}?section_id=vd-wishlist-card). Single source of truth: the hearts own the
   storage + toggle (vd-cards.js); this file only renders the page and stays in sync via the
   'vd:wishlist:changed' event. */
(function () {
  var KEY = 'vd_wishlist';
  var grid = document.querySelector('[grid-wishlist]');
  if (!grid || grid.__vdWishInit) return;
  grid.__vdWishInit = 1;

  function getList() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(Boolean) : [];
    } catch (e) { return []; }
  }
  function saveList(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }

  function setCount(n) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = String(n); });
  }

  function cardFor(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=vd-wishlist-card', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var box = document.createElement('div');
        box.innerHTML = html;
        var card = box.querySelector('.vd-card');
        return card || null; // handle no longer exists / unpublished → skip
      })
      .catch(function () { return null; });
  }

  // Fetch with limited concurrency, preserving wishlist order.
  function fetchCards(handles, limit) {
    var out = new Array(handles.length);
    var idx = 0;
    function worker() {
      if (idx >= handles.length) return Promise.resolve();
      var my = idx++;
      return cardFor(handles[my]).then(function (card) { out[my] = card; return worker(); });
    }
    var pool = [];
    for (var i = 0; i < Math.min(limit, handles.length); i++) pool.push(worker());
    return Promise.all(pool).then(function () { return out; });
  }

  var token = 0;
  function render() {
    var handles = getList();
    setCount(handles.length);
    var mine = ++token;
    if (!handles.length) { grid.innerHTML = ''; return; }
    grid.setAttribute('aria-busy', 'true');
    fetchCards(handles, 6).then(function (cards) {
      if (mine !== token) return; // a newer render superseded this one
      var frag = document.createDocumentFragment();
      var seen = {};
      cards.forEach(function (card, i) {
        var h = handles[i];
        if (!card || seen[h]) return;
        seen[h] = 1;
        frag.appendChild(card);
      });
      grid.innerHTML = '';
      grid.appendChild(frag);
      grid.removeAttribute('aria-busy');
      // Every card here is wishlisted → mark its heart active directly (don't depend on
      // vd-cards.js having executed yet, since script order can vary).
      grid.querySelectorAll('.vd-card__wish').forEach(function (b) {
        b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
      });
      // fill colourway swatches (needs vd-cards.js; defined by the time this async render resolves)
      if (window.vdInitSwatches) { try { window.vdInitSwatches(); } catch (e) {} }
    });
  }

  // Live sync: a heart toggled anywhere (incl. on this page) updates the grid.
  document.addEventListener('vd:wishlist:changed', function (e) {
    var d = e && e.detail;
    if (d && d.added === false && d.handle) {
      // remove just that card — no full refetch
      var card = grid.querySelector('.vd-card[data-vd-handle="' + d.handle + '"]');
      if (card) card.remove();
      setCount(getList().length);
      return;
    }
    render();
  });

  // Clear-all button.
  var clearBtn = document.querySelector('[data-wishlist-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      saveList([]);
      // the event drives render() here + heart reset in vd-cards.js
      document.dispatchEvent(new CustomEvent('vd:wishlist:changed', { detail: { handle: null, added: false } }));
    });
  }

  // Cross-tab sync.
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });

  render();
})();
